import React from "react";
import KuikaInfoBox from "../../ui-kit/kuika-info-box/kuika-info-box";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaSmallText from "../../ui-kit/typography/SmallText/SmallText";
import KuikaTextMedium from "../../ui-kit/typography/TextMedium/TextMedium";

/** Shown instead of the form when the organization has no running SLA contract (ACCOUNT_RESTRICTED). */
const HelpdeskRestrictedNotice = (): React.ReactElement => (
  <KuikaInfoBox
    color="yellow"
    leftUnit={
      <div className="kuika-helpdesk-restricted" role="alert" data-testid="helpdeskRestrictedNotice">
        <div className="kuika-flex--gap-xs kuika-align-center">
          <KuikaSvg name="alert-triangle" width={16} height={16} color="var(--yellow-7)" />
          <KuikaTextMedium>Your account is restricted.</KuikaTextMedium>
        </div>
        <KuikaSmallText>The company you belong to has no active SLA contract.</KuikaSmallText>
        <KuikaSmallText>Until the account is reactivated you cannot open tickets or send messages.</KuikaSmallText>
      </div>
    }
  />
);

export default HelpdeskRestrictedNotice;
